export default {
  "content": "<path clip-rule=\"evenodd\" d=\"M7.556 2.273a.497.497 0 01.887 0l5.48 9.874c.233.419-.09.853-.443.853H2.52c-.354 0-.676-.434-.443-.853zm2.636-.97a2.496 2.496 0 00-4.384 0l-5.48 9.873.86.478-.86-.478C-.596 12.841.543 15 2.52 15h10.96c1.977 0 3.116-2.159 2.192-3.824l-5.48-9.874zM9 6a1 1 0 00-2 0v2a1 1 0 102 0zm-1 6a1 1 0 100-2 1 1 0 000 2z\" fill=\"#ff00cb\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};